// extracted by mini-css-extract-plugin
module.exports = {"image":"credit-score-unactivated_image__1jBQx","textContainer":"credit-score-unactivated_textContainer__AU6dd"};